import React from 'react';
import styled from 'styled-components';

import DataUser from './DataUser';

import SimpleLoading from '../../../common/SimpleLoading';
import MenuPopover from './MenuPopover';

const HeaderBody = (props) => {
    const { statusUser, changeStatusChat, statusChat } = props;

    if (!statusUser) {
        return <SimpleLoading />;
    }

    return (
        <HeaderContent>
            <DataUser statusChat={statusChat} statusUser={statusUser} />
            <Button>
                <MenuPopover
                    statusChat={statusChat}
                    changeStatusChat={changeStatusChat}
                />
            </Button>
        </HeaderContent>
    );
};

export default HeaderBody;

const HeaderContent = styled.div`
    position: relative;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px;

    &::before {
        content: '';
        position: absolute;
        margin: auto;
        width: calc(100% - 4rem);
        height: 1px;
        background-color: #a8a8a8;
        bottom: 10px;
        left: 0;
        right: 0;
    }
`;

const Button = styled.div`
    cursor: pointer;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    :hover {
        background-color: #ededed;
    }
`;
